import React from 'react';

import Spinner from '../Spinner/index.jsx';
import ArticleReaction from '../ArticleReaction/index.jsx';
import articleModalService from '../../Services/ArticleModal/index.jsx';


class ArticleReactionSinglePost extends React.Component {
  
  constructor(props) {
    super(props);

    this.state = {
      ready: false,
      error: undefined,
      article: null
    };

    this.populateArticle = this.populateArticle.bind(this);
    this.fetchError = this.fetchError.bind(this);

  }

  /**
   * retrieve article details from the article slug.
   */
  componentDidMount() {
    this.populateArticle();
  }

  populateArticle() {
    articleModalService.fetchArticle(this.props.articleSlug)
    .then((result) => {
      if (result) {
        this.setState({
          article: result,
          ready: true
        });
      } else {
        console.error('Reaction Error: article not found or you may not have permission to access it!')
      }
    })
    .catch(this.fetchError);
  }

  fetchError(error) {
    this.setState({ error: error });
  }

  render() {
    var result;

    if (this.state.ready) {
      result = (
        <ArticleReaction
          onReactionUpdate={this.populateArticle}
          article={this.state.article}
        />
      );
    } else {
      result = <Spinner />;
    }

    
    return result;
  }
}

export default ArticleReactionSinglePost;

